import { render, staticRenderFns } from "./ItemAddBtnGroup.vue?vue&type=template&id=5c84cebd&scoped=true&"
import script from "./ItemAddBtnGroup.vue?vue&type=script&lang=js&"
export * from "./ItemAddBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./ItemAddBtnGroup.vue?vue&type=style&index=0&id=5c84cebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84cebd",
  null
  
)

export default component.exports